


export class CostReviewHumidifiers {
  numberOfHumidifires!: number;
  manufacturer!: string;
  unitsControlsFurnishedBy!: number;
  unitsControlsInstalledBy!: number;
  unitsControlsWiredBy!: number;
  isHumidifiersApplicable!: boolean;
}
